import {createQueryStringFromObject} from 'services/urlServices'
import {OrderAlert, OrderDisplayStatus, OrderStatus} from 'types/orderTypes'
import {ORDER_DISPLAY_ALERTS_MAP, ORDER_DISPLAY_STATUS_MAP} from 'constants/ordersConstants'
import {OrdersTableDataItem} from 'selectors'

export const createGetUrlWithCustomerKey = (getUrl: string, customerKey?: string) => {
  // we conditionally add the user's orgKey to the query params if needed
  if (customerKey) {
    let joinCharacter = '&'
    if (!getUrl.match(/\?([^&]+)=/)) {
      joinCharacter = '?'
    }
    getUrl = `${getUrl}${joinCharacter}${createQueryStringFromObject({
      orgKey: customerKey
    })}`
  }

  return getUrl
}

export const getAlertsByOrder = (order: OrdersTableDataItem): OrderAlert[] => {
  const alerts: OrderAlert[] = []
  const {status, paymentFailed, productOrderId} = order
  const {orderStatus, supportNeeded, hold, cancel, revision} = status

  if (hold?.isOnHold) {
    alerts.push('On Hold')
  }

  if (cancel?.cancelRequested) {
    alerts.push('Cancelation Requested')
  }

  if (revision?.revisionRequested) {
    alerts.push('Revision Requested')
  }

  if (orderStatus === 'ORDERED' && supportNeeded) {
    alerts.push('Contact Support')
  } else if (orderStatus === 'ORDERED' && paymentFailed) {
    alerts.push('Payment Failed')
  } else if (orderStatus === 'ORDERED' && !productOrderId) {
    alerts.push('Payment Processing')
  }

  return alerts
}

export const getOrderAlertTooltipTextByAlertType = (
  alertType: OrderAlert,
  order: OrdersTableDataItem
): string => {
  let text
  if (alertType === 'Contact Support' && order.opsOrderId) {
    text = `${ORDER_DISPLAY_ALERTS_MAP[alertType].text}${order.opsOrderId.slice(-5)}`
  } else {
    text = ORDER_DISPLAY_ALERTS_MAP[alertType].text ?? ''
  }

  return text
}

export const getOrderProgressStepByOrderStatus = (
  orderStatus: Exclude<OrderStatus, 'CANCELED'> | undefined
): number => {
  let step
  if (orderStatus === 'ORDERED' || orderStatus === 'ACCEPTED') {
    step = 0
  } else if (orderStatus === 'ASSIGNED') {
    step = 1
  } else if (orderStatus === 'REVIEWING') {
    step = 2
  } else if (orderStatus === 'COMPLETED') {
    step = 3
  } else {
    step = -1
  }
  return step
}

export const getOrderProgressStepNames = (): OrderDisplayStatus[] => {
  return [
    ORDER_DISPLAY_STATUS_MAP.ORDERED,
    ORDER_DISPLAY_STATUS_MAP.ASSIGNED,
    ORDER_DISPLAY_STATUS_MAP.REVIEWING,
    ORDER_DISPLAY_STATUS_MAP.COMPLETED
  ]
}
